import React from "react";
import { QuestionsAndAnswersItem } from "./QuestionsAndAnswersItem";
import { QUESTIONS_ANSWERS } from "./constants";

export const QuestionsAndAnswersList = () => (
  <div className="flex flex-col gap-3 mt-5 lg:mt-10">
    {QUESTIONS_ANSWERS.map((item) => (
      <QuestionsAndAnswersItem key={item.id} id={item.id} {...item} />
    ))}
  </div>
);
